import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminAssignSubmission = () => {
  //const [platforms, setPlatforms] = useState([]);
  //Sujay 9/6/2025 taking the plafrom from localstorage and featching the data
  const [PlatformID,setPlatformID] = useState();
  //const [selectedPlatformId, setSelectedPlatformId] = useState('');
  const [authors, setAuthors] = useState([]);
  const [selectedAuthorId, setSelectedAuthorId] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [selectedSubmissionId, setSelectedSubmissionId] = useState(null);
  const [reviewers, setReviewers] = useState([]);
  const [selectedReviewerIds, setSelectedReviewerIds] = useState([]);
  //Sujay 11/6/2025 adding the variable to cheak the paper is orignal or not 
  const [isOriginal, setIsOriginal] = useState(false);
  const [originalReviewers, setOriginalReviewers] = useState("");
  const API = process.env.REACT_APP_API_BASE_URL;

  //Sujay 9/6/2025 taking the plafrom from localstorage and featching the data
  useEffect(() => {
    axios.get(`${API}/api/subassignments/authors`)
      .then(res => setAuthors(res.data))
      .catch(err => console.error(err));

  })
  useEffect(()=>{
    axios.get(`${API}/api/subassignments/reviewers/${PlatformID}`)
      .then(res => {setReviewers(res.data)
      })
      .catch(err => console.error(err));
  },[PlatformID])

  // Fetch platforms on load
  // useEffect(() => {
  //   axios.get('${API}/api/host/platforms')
  //     .then(res => setPlatforms(res.data))
  //     .catch(err => console.error(err));
  // }, []);

  // // Fetch authors and reviewers when platform is selected
  // useEffect(() => {
  //   if (selectedPlatformId) {
  //     axios.get(`${API}/api/subassignments/authors`)
  //       .then(res => setAuthors(res.data))
  //       .catch(err => console.error(err));

  //     axios.get(`${API}/api/subassignments/reviewers/${selectedPlatformId}`)
  //       .then(res => setReviewers(res.data))
  //       .catch(err => console.error(err));
  //   }
  // }, [selectedPlatformId]);

  // Fetch submissions when an author is selected
  useEffect(() => {
    if (selectedAuthorId) {
      axios.get(`${API}/api/admin/submissions/unassign/${selectedAuthorId}`)
        .then(res => {setSubmissions(res.data)})
        .catch(err => console.error(err));
    }
  }, [selectedAuthorId]);

  // Submit handler
  // Submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedAuthorId || !selectedSubmissionId || (!isOriginal && originalReviewers.length === 0) || (isOriginal && selectedReviewerIds.length === 0) || !PlatformID) {
      alert('Please select all fields before submission.');
      return;
    }

    const reviewersToSubmit = isOriginal ? selectedReviewerIds : originalReviewers;

    axios.post(`${API}/api/subassignments/assign`, {
      AuthorID: selectedAuthorId,
      submissionID: selectedSubmissionId,
      ReviewerIDs: reviewersToSubmit,
      PlatformID: PlatformID
    }).then(res => {
      alert(res.data.message);
      setSelectedAuthorId(null);
      setSelectedSubmissionId(null);
      setSelectedReviewerIds([]);
      setOriginalReviewers([]);
      setIsOriginal(false);
    }).catch(err => {
      alert('Error saving assignment');
      console.error(err);
    });
  };


  //sujay 11/6/2025 adding the function to cheak the is orignal or not 
  const handleCheckOriginal = async (submissionID) => {
    try {
      const res = await axios.get(`${API}/api/subassignments/checkoriginal/${submissionID}`);
      setIsOriginal(res.data.isParent);

      const reviewerString = res.data.reviewers?.[0]?.ReviewerIDs || "";
      const reviewerArray = reviewerString
        .split(',')
        .filter(id => id.trim() !== "") // Remove empty strings if any
        .map(id => Number(id));

      

      setOriginalReviewers(reviewerArray);
    } catch (error) {
      console.error("Error checking original submission:", error);
      // Optional: handle error state or show a message to user
    }
  };


  return (
    <div className="container mt-4">
      <div className="p-4 ">
        <h3 className="mb-4 text-primary">Assign Submission to Reviewers</h3>

        {/* Platform selection */}

        {/* sujay 9/6/2025 hiding the platfromSelection part */}

        {/* <div className="mb-4">
          <label className="form-label fw-bold">Select Platform</label>
          <select className="form-select" value={selectedPlatformId} onChange={(e) => setSelectedPlatformId(e.target.value)}>
            <option value="">-- Select Platform --</option>
            {platforms.map(platform => (
              <option key={platform.PlatformID} value={platform.PlatformID}>
                {platform.PlatformName}
              </option>
            ))}
          </select>
        </div> */}

        {/* Author selection */}
        {authors.length > 0 && (
          <div className="mb-4">
            <h5 className="text-secondary">Select Author</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr><th>Select</th><th>Author Name</th><th>Email</th></tr>
                </thead>
                <tbody>
                  {authors.map(author => (
                    <tr key={author.AuthorID}>
                      <td>
                        <input
                          type="radio"
                          name="author"
                          value={author.AuthorID}
                          checked={selectedAuthorId === author.AuthorID}
                          onChange={() => setSelectedAuthorId(author.AuthorID)}
                        />
                      </td>
                      <td>{author.AuthorName}</td>
                      <td>{author.EmailID}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Submission selection */}
        {submissions.length > 0 ? (
          <div className="mb-4">
            <h5 className="text-secondary">Select Submission</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr><th>Select</th><th>Submission Title</th><th>Date</th></tr>
                </thead>
                <tbody>
                  {submissions.map(sub => (
                    <tr key={sub.submissionID}>
                      <td>
                        <input
                          type="radio"
                          name="submission"
                          value={sub.submissionID}
                          checked={selectedSubmissionId === sub.submissionID}
                          onChange={() => {
                            setSelectedSubmissionId(sub.submissionID)
                            setPlatformID(sub.PlatformID);
                            //sujay 11/6/2025 added the code to cheak the origanal paper or not
                            handleCheckOriginal(sub.submissionID)
                          }}
                        />
                      </td>
                      <td>{sub.SubmissionTitle}</td>
                      <td>{new Date(sub.submissiondate).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : <div class="alert alert-info fw-bold text-center mb-3 rounded shadow-sm" role="alert">
          This author does not have a paper to assign to a reviewer.
        </div>}



        {/* Reviewer selection */}
        {/* Reviewer selection */}
        {!isOriginal && reviewers.length > 0 && originalReviewers.length > 0 && (
          <div className="mb-4">
            <h5 className="text-secondary">Original Reviewers</h5>
            <ul className="list-group">
              {reviewers
                .filter(rev => originalReviewers.includes(rev.ReviewerID))
                .map(rev => (
                  <li key={rev.ReviewerID} className="list-group-item d-flex justify-content-between align-items-center">
                    <span>
                      <strong>{rev.ReviewerName}</strong> <small className="text-muted">({rev.EmailID})</small>
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        )}


        {isOriginal && reviewers.length > 0 && (
          <div className="mb-4">
            <h5 className="text-secondary">Select Reviewers (max 3)</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Select</th><th>Reviewer Name</th><th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {reviewers.map(rev => {
                    const id = rev.ReviewerID;
                    const checked = selectedReviewerIds.includes(id);
                    const disableUncheckable =
                      !checked && selectedReviewerIds.length >= 3;

                    return (
                      <tr key={id}>
                        <td>
                          <input
                            type="checkbox"
                            value={id}
                            checked={checked}
                            disabled={disableUncheckable}
                            onChange={() => {
                              setSelectedReviewerIds(prev =>
                                prev.includes(id)
                                  ? prev.filter(r => r !== id)
                                  : [...prev, id]
                              );
                            }}
                          />
                        </td>
                        <td>{rev.ReviewerName}</td>
                        <td>{rev.EmailID}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {selectedReviewerIds.length >= 3 && (
                <div className="text-danger mt-2">
                  You can select up to a maximum of 3 reviewers.
                </div>
              )}
            </div>
          </div>
        )}



        <button className="btn btn-primary" onClick={handleSubmit}>Assign</button>
      </div>
    </div>
  );
};

export default AdminAssignSubmission;
